if (!customElements.get('featured-collection-carousel')) {
  class FeaturedCollectionCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.swiper = null;
    }

    connectedCallback() {
      if (this.swiperEl) this.initSwiper();
    }

    disconnectedCallback() {
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') {
        setTimeout(this.initSwiper.bind(this), 50);
        return;
      }
      else {
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1.5,
          spaceBetween: 16,
          loop: false,
          freeMode: {
            enabled: true,
            sticky: false,
            momentumRatio: 0.5,
            momentumBounce: false
          },
          scrollbar: {
            el: this.querySelector('.featured-collection-carousel-scrollbar'),
            draggable: true,
          },
          breakpoints: {
            700: {
              slidesPerView: 2.5,
              spaceBetween: 16,
            },
            992: {
              slidesPerView: 4.5,
              spaceBetween: 16,
            },
          }
        });
      }
    }
  }
  customElements.define('featured-collection-carousel', FeaturedCollectionCarousel);
}